import { Button } from '@/components/ui/button';
import { CopyToClipboard } from 'widgets/CopyToClipboard';

export const CopyTaxIdButton = ({ value }: { value: string }) => (
    <CopyToClipboard textToCopy={value.replace(/-/g, '')} tooltip="Copy without dashes">
        <Button type="button" size="sm" variant="outline">
            Copy
        </Button>
    </CopyToClipboard>
);
